<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR PARAMETROS</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <!-- <data-table class="mt-5" @editar="editar($event)" @configurar_opciones="configurar_opciones($event)"></data-table> -->
            <data-table-filtro class="mt-5" @editar="editar($event)" @configurar_opciones="configurar_opciones($event)"></data-table-filtro>
            

            <modal @peticionrealizada="cargarDatos"></modal>

            <!-- modal de configuracion de opciones (para parametro de tipo select) -->
            <modal-opciones></modal-opciones>
            <!-- modal de configuracion de opciones (para parametro de tipo select) -->

    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
// import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Modal_Configuracion_Opcion from '@/components/shared/Modal_Configuracion_Opcion.vue';
import Data_Table_Filtro from '../../components/shared/Data_Table_Filtro.vue'

// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        tipos_parametros:[
            {id:'numero',tipo_parametro:'Número'},
            {id:'select',tipo_parametro:'Seleccionable'}
        ],
        inputs:[
            {tipo:'texto',valor:'',label:'Nombre Parametro*',key:'nombre_parametro'},
            {tipo:'texto',valor:'',label:'Nombre Corto*',key:'nombre_corto'},
            {tipo:'texto',valor:'',label:'Nombre PDF Cesmec',key:'nombre_pdf_cesmec', info: 'Nombre de parámetro que corresponde a nombre utilizado en PDFs de los muestreos de los lotes de laboratorio Cesmec'},
            {tipo:'select',valor:'',label:'Seleccione Tipo Parámetro*',key:'tipo',opciones:[],texto:'tipo_parametro',seleccion:'id'},
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:''
        },
        //configuracion para datatable
        cabeceras:[
            {
                text:'Nombre Parametro',
                align:'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value:'nombre_parametro',
                class:'cabecera'
            },
            {
                text: 'Nombre Corto',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'nombre_corto',
                class:'cabecera'
            },
            {
                text: 'Nombre PDF Cesmec',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'nombre_pdf_cesmec',
                class:'cabecera'
            },
            {
                text: 'Tipo',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'tipo',
                class:'cabecera'
            },
            {
                text: 'Opciones',
                align: 'center',
                sortable: false,
                filterable:false,
                value: 'configurar_opciones_parametro',
                class:'cabecera'
            },
            { 
                text: 'Acciones', 
                value: 'action', 
                sortable: false,
                filterable:false,
                align:'center' ,
                class:'cabecera'
            },
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarDatos()
        this.inputs[3].opciones = this.tipos_parametros;
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...')
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}parametros`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                // Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones)
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Parametro'
            this.configuracion_modal.boton_submit = 'Crear'
            this.configuracion_modal.ruta = 'parametros'
            this.configuracion_modal.tipo_peticion = 'POST'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            this.inputs.forEach(input => {
                input.valor = $event[input.key];
            });

            const tipo_parametro = this.tipos_parametros.find(tipo => tipo.id === $event.tipo);
            this.inputs[3].valor = tipo_parametro;
            
            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Parametro'
            this.configuracion_modal.boton_submit = 'Actualizar'
            this.configuracion_modal.ruta = `parametros/${$event.id}`
            this.configuracion_modal.tipo_peticion = 'PUT'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        configurar_opciones($event){
            console.log('configurar_opciones',$event['id']);
            Event.$emit('abrir_modal_configuracion_opciones',$event);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        // 'data-table':Data_Table,
        'data-table-filtro':Data_Table_Filtro,
        'modal-opciones':Modal_Configuracion_Opcion
    }
}
</script>